<template>
  <section class="message-new-etf rem-wrapper ">
    <p class="p1 mobile scroll-fade-up">没有找到你想交易的 ETF？</p>
    <p class="p2 mobile scroll-fade-up md-footnote-regular_12">输入你关注的 ETF 名称或代码，我们将根据产品覆盖与市场需求进行评估。</p>
    <img class="message-pro scroll-fade-left" src="../../assets/image/message/pro.png" alt="">
    <div class="form-box contact-us scroll-fade-right">
      <p class="p1 pc">没有找到你想交易的 ETF？</p>
      <p class="p2 pc content-16_regular md-footnote-regular_12">输入你关注的 ETF 名称或代码，我们将根据产品覆盖与市场需求进行评估。</p>
      <div class="form-group">
        <input type="text" id="etfCode" name="etfCode" v-model="infoData['etf-code']" class="input-field"
          placeholder="ETF名称或代码">
      </div>
      <div class="form-group">
        <input type="email" id="email" name="email" v-model="infoData.email" class="input-field"
          placeholder="邮箱">
      </div>
      <div class="form-group">
        <div class="captcha-container">
          <input id="verify" v-model="code" type="text" class="input-field"
            :placeholder="$t('CFooters.contactUs.code')">
          <div class="verify-code" @click="refreshCode"><ss-code :identifyCode="identifyCode"></ss-code></div>
        </div>
      </div>
      <button type="submit" class="contact-submit" id="contact-submit" @click="getContact">{{ $t('message.立即参与') }}<img
          class="icon-arrow" src="../../assets/image/message/arrow.svg" alt="" /></button>
    </div>
  </section>
</template>

<script>
import md5 from 'js-md5';
export default {
  props: {
    mode: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      sexIndex: 0,
      infoData: {
        'etf-code': '',
        email: ''
      },
      code: null,
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
      identifyCode: "", //验证码图片内容
    }
  },
  mounted() {
    // 初始化验证码
    this.identifyCode = "";
    //参数：（1）随机串内容。（2）验证码显示位数
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //获取验证码的值
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        //通过循环获取字符串内随机几位
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    //随机数字：用于当角标拿字符串的值
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    getContact() {
      let infoData = {
        ...this.infoData
      }

      if (!infoData['etf-code']) return this.$toast('请输入ETF名称或代码');
      if (!infoData.email) return this.$toast(this.$t('请输入邮箱'));
      if (this.identifyCode != this.code) {
        this.code = null
        return this.$toast(this.$t('CFooters.contact.tips4'));
      }
     fetch('https://ebccfd.com/contact-us/ETFSubmit/',{method:'POST',headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						...infoData,
            lang:'cn'
					}),}).then(res=>res.json()).then(res=>{
            this.$toast(this.$t('CFooters.contact.tips3'))
        this.code = null
        this.infoData = {
           'etf-code': '',
            email: ''
        }
          })
          return
      
    },
    changeSix(index) {
      this.sexIndex = index
    },
  }
}

</script>

<style lang="scss">
.s-canvas {
  border-radius: 4rem;
  overflow: hidden;
}


.message-new-etf {
  display: flex;
  justify-content: space-between;
  padding: 120rem 0;
  background-image: url('../../assets/image/message/bg.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  align-items: center;
   max-width: 1200rem;
    padding-inline: calc((100vw - 1200rem) / 2) !important;
    box-sizing: content-box;
}

.icon-arrow {
  width: 24rem;
}

.message-pro {
  width: 588rem;
}

.message-new-etf .p1 {
  color: var(--Text-Primary_White, #fff);
  font-family: Sinter;
  font-size: 40rem;
  font-style: normal;
  font-weight: 700;
  line-height: 48rem;
  /* 120% */
  margin-bottom: 20rem;
}

.message-new-etf .form-box {
  width: 490rem;
}

.message-new-etf .form-group {
  margin-bottom: 25rem;
  position: relative;
}

.message-new-etf .input-field {
  width: 100%;
  padding: 10rem 0;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  color: white;
  font-size: 16rem;
  outline: none;
}

.message-new-etf .gender-selector {
  display: flex;
  gap: 15rem;
  margin-top: 5rem;
  position: absolute;
  right: 0;
  top: -4rem;
}

.message-new-etf .gender-btn {
  position: relative;
  padding: 5rem 15rem 5rem 24rem;
  background: transparent;
  color: white;
  cursor: pointer;
  font-size: 16rem;
}

.message-new-etf .gender-btn::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 14rem;
  height: 14rem;
  border: 1px solid #fff;
  border-radius: 50%;
  transform: translateY(-50%);
}

.message-new-etf .gender-btn.select-label--active::before {
  border: 5rem solid #fff;
}

.message-new-etf .gender-btn {
  padding: 5rem 15rem 5rem 30rem;
}

.message-new-etf .gender-btn::before {
  width: 22rem;
  height: 22rem;
}

.message-new-etf .gender-btn.select-label--active::before {
  border: 8rem solid #fff;
}

.message-new-etf .captcha-container {
  display: flex;
  gap: 10trm;
  align-items: center;
}

.message-new-etf .captcha-code {
  padding: 5rem 10rem;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  border-radius: 4rem;
}

.message-new-etf .contact-submit {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 48rem;
  padding: 0 24rem;
  gap: 8rem;
  border-radius: 24rem;
  background: var(--Brand-Secondary-Red, #a52933);
  color: var(--Text-Primary_White, #fff);
  text-align: center;
  font-size: 16rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  margin-top: 46rem;
  width: 100%;
}

.message-new-etf .contact-submit:hover {
  background: var(--Functional-Active-Hover, #cc333f);
  color: var(--Text-Primary_White, #fff);
}

.message-new-etf .contact-submit:active {
  background: var(--Functional-Active-Pressed, #7b1e26);
  color: var(--Text-Primary_White, #fff);
}

.message-new-etf ::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.message-new-etf #name {
  padding-right: 180rem;
}

@media (max-width: 996px) {

  .message-new-etf .p1 {
    text-align: center;
    font-size: 48rem;
    line-height: 1.4;
    margin-bottom: 0;
    padding: 0 32rem;
  }

  .message-new-etf .input-field {
    font-size: 14px;
    padding: 10px 0;
  }

  .message-new-etf .gender-btn {
    font-size: 14px;
  }

  .message-new-etf .contact-submit {
    height: 96rem;
    border-radius: 48rem;
    font-size: 32rem;
    font-style: normal;
    font-weight: 500;
    line-height: 56rem;
    padding: 0 48rem;
    width: 100%;
  }

  .message-new-etf .form-group {
    margin-bottom: 22px;
  }

  .message-new-etf .gender-selector {
    top: 4px;
  }

  .message-new-etf .form-box {
    width: calc(100% - 64rem);
    padding-bottom: 0px;
  }

  .message-new-etf {
    padding: 160rem 0;
    flex-direction: column;
    align-items: center;
    gap: 64rem;
  }

  .message-new-etf #name {
    padding-right: 240rem;
  }

  .s-canvas {
    border-radius: 8rem;
  }

  .icon-arrow {
    width: 48rem;
  }
}

.message-new-etf .p2 {
    color: rgba(255, 255, 255, 0.80);
    margin-bottom: 48rem;
}
@media (max-width: 996px) {
    .message-new-etf .p2 {
        max-width: calc(100% - 64rem);
        text-align: center;
        margin-block: -40rem -15rem;
    }
}
</style>
